<template>
  <div class="layout-mgt layout-mgt-display layout-mgt-add">
    <div class="layout-mgt-panel">
      <div>
        <div class="layout-mgt-panel-rows" v-for="(row, i) in rows" :key="i">
          <ul class="layout-mgt-panel-controls">
            <li v-for="(item, i) in row.controls" class="layout-mgt-panel-control" :key="i">
              <span v-if="item.type=='Label'">{{item.text}}</span>
              <input type="text" v-if="item.type=='TextBox'" v-bind:name="item.name" v-bind:placeholder="item.text" class="form-control" v-date="item.date" />
              <label v-if="item.type=='CheckBox'"><input type="checkbox" v-bind:name="item.name" v-bind:value="item.value" /> {{item.text}}</label>
              <label v-if="item.type=='RadioButton'"><input type="radio" v-bind:name="item.name" v-bind:value="item.value" /> {{item.text}}</label>
              <select v-if="item.type=='DropDownList'" v-bind:name="item.name" class="form-control">
                <option value="">{{item.text}}</option>
                <option v-for="(option, i) in item.options" :key="i" v-bind:value="option.value">{{option.text}}</option>
              </select>
              <textarea v-if="item.type=='TextArea'" v-bind:name="item.name" v-bind:placeholder="item.text" class="form-control"></textarea>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { forms, formsValues } from "resource";
export default {
  data: function() {
    return {
      id: this.$route.params.id,
      layoutId: this.$route.params.layoutId,
      rows: [
        {
          controls: [],
          value: null
        }
      ],
      editItem: {},
      controlNo: 1
    };
  },
  directives: {
    date: {
      bind: function(el, binding) {
        if (binding.value === true) {
          $(el).datetimepicker({
            lang: "ch",
            timepicker: false,
            format: "Y/m/d"
          });
        }
      }
    }
  },
  methods: {
    layout(a) {
      if (a) {
        this.rows = JSON.parse(a);
      }
    },
    async values(a) {
      if (a) {
        let json = JSON.parse(a),
          el = $(this.$el);
        await this.$nextTick();
        $(json.data).each(function() {
          el.find("[name=" + this.name + "]:not(:radio,:checkbox)").val(
            this.value
          );
          el.find("[name=" + this.name + '][value="' + this.value + '"]').prop(
            "checked",
            true
          );
        });
        return;
      }
      var data = $(this.$el)
        .find("input,select,textarea")
        .serializeArray();
      return JSON.stringify({ layoutId: this.id, data: data });
    }
  }
};
</script>
<style>
.layout-mgt {
  /* background: #ccc; */
  min-height: 300px;
  position: relative;
  padding: 0;
}

.layout-mgt-panel-header {
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

.layout-mgt-tools {
  position: absolute;
  right: 0;
  top: 0;
  background: #e0e0e0;
  padding: 0;
  width: 150px;
}

.layout-mgt-tools ul {
  list-style: none;
  padding: 0;
}

.layout-mgt-tools li {
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}

.layout-mgt-tools h4 {
  padding: 10px;
  margin: 0;
  text-align: center;
  background: #ccc;
}

.layout-mgt-tools a {
  color: #fff;
  display: block;
  padding: 5px 10px;
}

.layout-mgt-tools a:hover {
  background: #eee;
}

.layout-mgt-tools .fas,
.layout-mgt-tools .far {
  margin-right: 10px;
  width: 20px;
  text-align: right;
}

.layout-mgt-tools-fixed {
  position: fixed;
  top: 114px;
  right: 60px;
}

.layout-mgt-panel {
  /* background: #ccc; */
  height: 100%;
  margin-right: 150px;
  padding: 10px;
  padding-top: 0;
}
.layout-mgt-panel input,
.layout-mgt-panel textarea {
  background: #fff;
}
.layout-mgt-panel select {
  color: #999;
}

.layout-mgt-panel ul {
  margin: 0;
  list-style: none;
  min-height: 40px;
  background: #e0e0e0;
  padding: 0;
  margin: 5px 0 0 0;
}

.layout-mgt-panel ul:after {
  content: "";
  clear: both;
  display: block;
}

.layout-mgt-panel ul:first-child {
  margin: 0;
}

.layout-mgt-panel li {
  float: left;
  white-space: nowrap;
  line-height: 26px;
  padding: 5px 10px;
  border: 2px solid transparent;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  color: #000;
}

.layout-mgt-panel li.layout-mgt-panel-control:hover {
  border: 2px solid #3c8dbc;
}

.layout-mgt-panel li input {
  line-height: normal;
}

.layout-mgt-panel li.layout-mgt-sort-placeholder {
  background: #ffd800;
  height: 40px;
  width: 10px;
  padding: 0;
}

.layout-mgt-panel li.ui-draggable-handle {
  padding: 0;
  line-height: normal;
  border: none;
}

.layout-mgt-panel li.ui-draggable-handle a {
  color: #000000;
  display: block;
  padding: 5px 10px;
}

.layout-mgt-panel li.ui-draggable-handle .fa {
  margin-right: 10px;
  width: 20px;
  text-align: right;
}

.layout-mgt-panel-rows {
  margin-top: 5px;
  position: relative;
  padding-left: 20px;
  padding-right: 15px;
}

.layout-mgt-panel-rows a.btn-move,
.layout-mgt-panel-rows a.btn-remove {
  position: absolute;
  left: 0;
  top: 0;
  line-height: 40px;
}

.layout-mgt-panel-rows a.btn-remove {
  left: auto;
  right: 0;
}

.layout-mgt-panel-control {
  position: relative;
}

.layout-mgt-panel-control label:after {
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  /*background: #ccc;*/
  position: absolute;
  top: 0;
  left: 0;
}

.options {
  position: relative;
  padding: 0 15px 0 0;
}

.options .btn-remove {
  position: absolute;
  top: 0;
  line-height: 34px;
  right: 15px;
  z-index: 1;
}

.layout-mgt-display {
  min-height: inherit;
  background: none;
}

.layout-mgt-display .layout-mgt-panel {
  padding: 0;
  margin: 0;
  background: none;
}

.layout-mgt-display .layout-mgt-panel-rows {
  margin-top: 1px;
  padding: 0;
}

.layout-mgt-display .layout-mgt-panel li.layout-mgt-panel-control:hover {
  border: 2px solid transparent;
}

.layout-mgt-add .layout-mgt-panel ul {
  background: none;
}

.layout-mgt-add .layout-mgt-panel li {
  padding: 5px 10px 5px 0;
}

.layout-mgt-add .layout-mgt-panel select {
  color: #555;
}
</style>